import { makeAutoObservable } from 'mobx'

class AppAssignmentsStore {
	updatedAt = null
	assignments = []
	loadStatus = 'idle'
	lastEtag = null

	constructor() {
		makeAutoObservable(this, {}, { autoBind: true })
	}

	setPayload(payload) {
		const nextEtag = payload?.updatedAt || null
		if (nextEtag && nextEtag === this.lastEtag) {
			this.loadStatus = 'success'
			return false
		}
		this.lastEtag = nextEtag
		this.updatedAt = nextEtag
		this.assignments = Array.isArray(payload?.assignments) ? payload.assignments : []
		this.loadStatus = 'success'
		return true
	}

	setLoading() {
		this.loadStatus = 'loading'
	}

	setError() {
		this.loadStatus = 'error'
	}

	get assignmentsByTargetId() {
		const map = new Map()
		this.assignments.forEach(item => {
			const key = String(item?.applicationTargetId || '').trim()
			if (!key) return
			if (!map.has(key)) map.set(key, [])
			map.get(key).push(item)
		})
		return map
	}
}

export const appAssignmentsStore = new AppAssignmentsStore()
